import { useEffect, useState } from "react";
import { getCtx, initSfx, playLoop } from "@/lib/sfx";
import { enterKiosk, keepAwake } from "@/lib/device";

const HUM = { name: "boot_drone", gain: 0.3, xfade: 4 };
const nextGlitchMs = () => 8000 + Math.random() * 12000;

// Final resting screen: pulsing title, seamless low hum, occasional subtle glitch. Stays until RESET.
export default function HoldScreen() {
  const [glitch, setGlitch] = useState(false);
  const [humOn, setHumOn] = useState(false);

  useEffect(() => {
    keepAwake(true);
    let hum = null;
    let alive = true;
    const startHum = () => {
      initSfx();
      const ctx = getCtx();
      if (!ctx || hum || !alive) return;
      if (ctx.state !== "running") ctx.resume().catch(() => {});
      hum = playLoop(HUM.name, HUM);
      hum.then((h) => {
        if (!alive) return h?.stop(0.1);
        setHumOn(Boolean(h));
        if (!h) hum = null;
      });
    };
    const onTap = () => {
      enterKiosk();
      startHum();
    };
    if (getCtx()?.state === "running") startHum();
    window.addEventListener("pointerdown", onTap);
    return () => {
      alive = false;
      window.removeEventListener("pointerdown", onTap);
      hum?.then((h) => h?.stop(0.3));
    };
  }, []);

  useEffect(() => {
    let t;
    const schedule = () => {
      t = setTimeout(() => {
        setGlitch(true);
        window.__sporeHoldGlitches = (window.__sporeHoldGlitches || 0) + 1;
        t = setTimeout(() => { setGlitch(false); schedule(); }, 260 + Math.random() * 200);
      }, nextGlitchMs());
    };
    schedule();
    return () => clearTimeout(t);
  }, []);

  return (
    <div className="hold" data-testid="hold-screen" data-hum={humOn ? "on" : "off"}>
      <h1 className={`hold-title glow ${glitch ? "hold-glitch" : ""}`} data-testid="hold-title" data-text="COMMUNICATION COMMENCING">
        COMMUNICATION COMMENCING
      </h1>
    </div>
  );
}
